var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4229 12.7025H5.17285C4.24459 12.7025 3.35435 13.08 2.69798 13.752C2.0416 14.424 1.67285 15.3354 1.67285 16.2858V23.4525C1.67285 24.4028 2.0416 25.3143 2.69798 25.9863C3.35435 26.6583 4.24459 27.0358 5.17285 27.0358H10.4229M17.4229 23.4525H29.6729C30.6011 23.4525 31.4913 23.0749 32.1477 22.4029C32.8041 21.7309 33.1729 20.8195 33.1729 19.8691V12.7025C33.1729 11.7521 32.8041 10.8407 32.1477 10.1687C31.4913 9.49667 30.6011 9.11914 29.6729 9.11914H24.4229",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4229 12.7031V5.53646C10.4229 4.5861 10.7916 3.67466 11.448 3.00266C12.1044 2.33065 12.9946 1.95313 13.9229 1.95312H20.9229C21.8511 1.95313 22.7413 2.33065 23.3977 3.00266C24.0541 3.67466 24.4229 4.5861 24.4229 5.53646V14.4948C24.4229 15.4452 24.0541 16.3566 23.3977 17.0286C22.7413 17.7006 21.8511 18.0781 20.9229 18.0781H13.9229C12.9946 18.0781 12.1044 18.4557 11.448 19.1277C10.7916 19.7997 10.4229 20.7111 10.4229 21.6615V30.6198C10.4229 31.5702 10.7916 32.4816 11.448 33.1536C12.1044 33.8256 12.9946 34.2031 13.9229 34.2031H20.9229C21.8511 34.2031 22.7413 33.8256 23.3977 33.1536C24.0541 32.4816 24.4229 31.5702 24.4229 30.6198V23.4531M15.6729 7.32812V7.34604M19.1729 28.8281V28.846",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory02);
export default __webpack_public_path__ + "static/media/category-02.1f1323099fbd948834b1b12c11736415.svg";
export { ForwardRef as ReactComponent };